import React from "react";
import styled from "styled-components";
import { FONTS, COLORS, BREAKPOINTS } from "../utils/styleConstants";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--background-color);
`;

const MainContent = styled.main`
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const Title = styled.h1`
  color: ${COLORS.SECONDARY};
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-family: ${FONTS.PRIMARY};
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: ${COLORS.PRIMARY};
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-family: ${FONTS.PRIMARY};
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  color: ${COLORS.TEXT};
  font-family: ${FONTS.SECONDARY};
`;

const PrivacyPage = () => {
  return (
    <PageContainer>
      <Header />
      <MainContent>
        <Title>Política de Privacidad</Title>
        
        <Section>
          <SectionTitle>1. Información que Recopilamos</SectionTitle>
          <Paragraph>
            En Ofertas Vinculantes, nos comprometemos a proteger tu privacidad. Este documento explica qué información personal recopilamos, cómo la utilizamos y las medidas que tomamos para protegerla.
          </Paragraph>
          <Paragraph>
            Recopilamos información que nos proporcionas directamente, como tu nombre, dirección de correo electrónico, número de teléfono y cualquier otra información que decidas compartir con nosotros al utilizar nuestros servicios, registrarte en nuestra plataforma o comunicarte con nosotros.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>2. Uso de la Información</SectionTitle>
          <Paragraph>
            Utilizamos la información recopilada para proporcionar, mantener y mejorar nuestros servicios, procesar transacciones, enviar notificaciones y comunicarnos contigo sobre actualizaciones, promociones y eventos.
          </Paragraph>
          <Paragraph>
            También podemos utilizar la información para personalizar tu experiencia, analizar cómo utilizas nuestros servicios y desarrollar nuevos productos y funcionalidades.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>3. Protección de Datos</SectionTitle>
          <Paragraph>
            Implementamos medidas de seguridad técnicas, administrativas y físicas diseñadas para proteger la información personal contra accesos no autorizados, destrucción o alteración. Sin embargo, ningún método de transmisión por Internet o método de almacenamiento electrónico es 100% seguro.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>4. Tus Derechos</SectionTitle>
          <Paragraph>
            Tienes derecho a acceder, corregir, actualizar o solicitar la eliminación de tu información personal. También puedes oponerte al procesamiento de tu información personal, pedirnos que restrinjamos el procesamiento de tu información personal o solicitar la portabilidad de tu información personal.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>5. Contacto</SectionTitle>
          <Paragraph>
            Si tienes preguntas o inquietudes sobre nuestra Política de Privacidad o nuestras prácticas con respecto a tu información personal, contáctanos en: founders@ofertasvinculantes.es
          </Paragraph>
        </Section>
      </MainContent>
      <Footer />
    </PageContainer>
  );
};

export default PrivacyPage; 